import { HomeOutlined } from '@ant-design/icons';
import { Button, Form, Input, Modal } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import calls from '../api/calls';

export const NewInvestmentButton = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [values, setValues] = useState<{ name: string }>({ name: '' });
  const [loading, setLoading] = useState(false);

  const formChangeHandler = (changedValues) => setValues({ ...values, ...changedValues });

  const formHandler = async () => {
    setLoading(true);
    try {
      await calls.investments.createInvestment(values.name);
      setVisible(false);
    } finally {
      setLoading(false);
    }
  };

  const modalCancelHandler = () => {
    setVisible(false);
  };

  const buttonClickHandler = () => {
    setVisible(true);
  };

  const renderModalButtons = () => [
    <Button key="cancel" onClick={modalCancelHandler} loading={loading}>
      {t('cancel')}
    </Button>,
  ];

  return (
    <>
      <Button type="ghost" style={{ width: '100%', marginBottom: 16 }} onClick={buttonClickHandler} loading={loading}>
        {t('newInvestment')}
      </Button>
      <Modal title={t('newInvestment')} visible={visible} closable={false} footer={renderModalButtons()}>
        <Form onFinish={formHandler} onValuesChange={formChangeHandler}>
          <Form.Item name="name" rules={[{ required: true, message: t('textInvalid'), type: 'string' }]}>
            <Input
              value={values.name}
              type="name"
              placeholder={t('name')}
              prefix={<HomeOutlined />}
              readOnly={loading}
            />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} className="pg-u-full-width">
            {t('submit')}
          </Button>
        </Form>
      </Modal>
    </>
  );
};
